//SnackBar.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";

import { Icon, IconButton, Snackbar } from "@mui/material";

import React from "react";

//Module level variables.
let msg: string = null;
let autoCloseTime: number = 3000;
let backColor: string = "#ffd54f";
let active = false;

let showRef: () => void; //Ref to showIt method inside render.
let hideRef: () => void; //Ref to hideIt method inside render.

export function show(message: string, autoCloseTimeSeconds?: number, backgroundColor?: string): void {
   msg = message;
   if (autoCloseTimeSeconds) {
      autoCloseTime = autoCloseTimeSeconds * 1000; //Convert to milliseconds.
   }
   if (backgroundColor) {
      backColor = backgroundColor;
   }

   active = true;
   showRef();
}
export function hide(): void {
   hideRef();
}

export function Render() {
   //Util.logMsg("Top of SnackBar Render");
   const [visible, setVisible] = React.useState(false); //Set refresh method.

   function showIt() {
      if (msg) {
         setVisible(true);  //Render and show SnackBar.
      }
   }

   function hideIt() {
      setVisible(false); //Hide SnackBar.
   }

   const showRef2 = React.useRef(showIt);
   const hideRef2 = React.useRef(hideIt);

   //Component did mount. Set module level variables.
   React.useEffect(() => {
      showRef = showRef2.current;
      hideRef = hideRef2.current;
   }, []);

   //Component did update. Reset the module level defaults in case they were changed by calling arguments.
   React.useEffect(() => {
      //msg = "";
      //autoCloseTime = 999999999;
      //backColor = "#ffd54f";
   });

   const styles: Default.iStyles = {
      backColor: { color: "black", backgroundColor: backColor, padding: 9, borderRadius: 4 },
   };

   if (active) {
      if (!visible) {
         active = false;
      }
      return (
         <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={visible}
            ContentProps={{ 'aria-describedby': 'message-id' }}
            autoHideDuration={autoCloseTime}
            message={<span id='message-id' style={styles.backColor}>{msg}</span>}
            onClose={hide}
            action={[
               <IconButton
                  key="close"
                  aria-label="Close"
                  color="primary"
                  onClick={hide}
               >
                  <Icon>close</Icon>
               </IconButton>,
            ]}
         />
      ); //end return.

   } else {
      return (<div />);
   }

} //end function.
